import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-white overflow-hidden" data-id="element-13">
      <div className="container mx-auto px-6 md:px-12" data-id="element-14">
        {/* Mobile Title (visible only on mobile) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="md:hidden mb-12" data-id="element-15">
          <h2 className="font-heading text-4xl mb-4 text-dark" data-id="element-16">Про мене</h2>
          <div className="w-12 h-px bg-accent" data-id="element-17"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-18">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative order-1" data-id="element-19">
            <div className="aspect-[3/4] w-full max-w-md mx-auto relative" data-id="element-20">
              <div className="w-full h-full bg-[#F9F9F9] border border-gray-100 rounded-t-full flex items-center justify-center" data-id="element-21">
                <div className="text-center" data-id="element-22">
                  <p className="text-xs text-gray-400 font-light tracking-widest uppercase" data-id="element-23">
                    Портрет майстра
                  </p>
                </div>
              </div>
              <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-white rounded-full flex items-center justify-center border border-gray-100 shadow-sm" data-id="element-24">
                <div className="text-center" data-id="element-25">
                  <span className="block font-heading text-3xl text-accent" data-id="element-26">
                    12+
                  </span>
                  <span className="text-[10px] uppercase tracking-widest text-gray-500" data-id="element-27">
                    років
                  </span>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-2" data-id="element-28">
            {/* Desktop Title (hidden on mobile) */}
            <div className="hidden md:block" data-id="element-29">
              <h2 className="font-heading text-4xl md:text-5xl text-dark mb-6" data-id="element-30">
                Про мене
              </h2>
              <div className="w-12 h-px bg-accent mb-8" data-id="element-31"></div>
            </div>

            <div className="space-y-6 text-gray-600 font-light leading-relaxed" data-id="element-32">
              <p data-id="element-33">
                Привіт! Я Валентина — майстер-перукар та колорист з понад
                12-річним досвідом. Моя місія — не просто змінити вашу зачіску,
                а підкреслити вашу індивідуальність та природну красу.
              </p>
              <p data-id="element-34">
                Я постійно навчаюсь, відвідую міжнародні майстер-класи та
                слідкую за останніми трендами у світі б'юті-індустрії. Для мене
                важливо використовувати лише якісні та безпечні матеріали, щоб
                ваше волосся завжди виглядало здоровим та доглянутим.
              </p>
              <p className="italic text-dark font-medium border-l-2 border-accent pl-4 py-2" data-id="element-35">
                "Краса волосся починається з його здоров'я. Моя мета — навчити
                вас любити своє волосся та правильно за ним доглядати."
              </p>
            </div>

            <div className="mt-10" data-id="element-36">
              <div className="h-12 w-32 border-b border-gray-300 flex items-end pb-2" data-id="element-37">
                <span className="text-[10px] text-gray-400 uppercase tracking-widest" data-id="element-38">
                  Підпис
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}